import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss'],
})
/**
 * Steps molecule that aggregates many step atoms and
 * has an idea of which step is active
 */
export class StepsComponent {
  @Input() numberOfSteps: number = 0;
  @Input() activeStep: number = 0;

  /**
   * Knows if a certain step is the active one
   * @param {number} step step to query if it is the active one
   * @return {boolean} if @param step is active
   */
  isActive(step: number): boolean {
    return this.activeStep * 2 - 1 === step;
  }
}
